import React from "react";
import { AreaChart, Area, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ReferenceDot } from "recharts";

// Area / Line chart supporting smooth spline curves, soft gradient fill,
// dashed reference line, and a floating 'Peak: 4,110' pill badge.
export default function TspLineChart({ data, xKey, series, peak, height = 220, xInterval = 0 }) {
  const isDense = (data || []).length >= 10;
  return (
    <div className="tsp-line-chart" style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 28, right: 10, left: -14, bottom: 0 }}>
          <defs>
            <linearGradient id="tspAreaGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#ea580c" stopOpacity={0.25} />
              <stop offset="95%" stopColor="#ea580c" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#EEF1F6" />
          <XAxis
            dataKey={xKey}
            tickLine={false}
            axisLine={false}
            fontSize={isDense ? 10 : 11}
            stroke="#9AA3B2"
            interval={xInterval}
            minTickGap={2}
          />
          <YAxis tickLine={false} axisLine={false} fontSize={10} stroke="#9AA3B2" width={32} />
          <Tooltip />
          {/* Main filled area */}
          <Area type="monotone" dataKey="actual" stroke="#ea580c" strokeWidth={2.5} fill="url(#tspAreaGrad)" dot={false} activeDot={{ r: 5, fill: "#ea580c" }} />
          {/* Dashed target line if present */}
          {series.find((s) => s.dashed) && (
            <Line
              type="monotone"
              dataKey="target"
              name="Target"
              stroke="#94a3b8"
              strokeWidth={1.8}
              strokeDasharray="4 4"
              dot={false}
              activeDot={{ r: 4 }}
            />
          )}
          {peak && (
            <ReferenceDot
              x={peak.x}
              y={peak.y}
              r={4}
              fill="#1e293b"
              stroke="#fff"
              strokeWidth={2}
              label={{
                value: peak.label,
                position: "top",
                fontSize: 11,
                fill: "#fff",
                className: "tsp-peak-badge",
              }}
            />
          )}
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
